import { useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { TrainingAsessmentAPI } from '../api/trainingAssessmentApi';
import { TrainingAssessment } from '../types/trainingAssessment';

type UseTrainingAssessmentOptions = {
  enabled?: boolean;
  showErrorToast?: boolean;
};

export const useTrainingAssessment = (
  documentId: TrainingAssessment['document_id'] | string | undefined,
  { enabled = true, showErrorToast = true }: UseTrainingAssessmentOptions = {},
) => {
  const { t } = useTranslation();
  const nbrId =
    typeof documentId === 'string' ? Number.parseInt(documentId) : documentId;
  const { showToast } = useToastProvider();
  return useQuery({
    queryKey: ['trainingAssessment', documentId],
    queryFn: () =>
      TrainingAsessmentAPI.getTrainingAssessmentForDocument(nbrId ?? 0),
    enabled,
    onError: () => {
      if (!showErrorToast) {
        return;
      }
      showToast({
        'data-cy': 'use-training-assessment-notify-error-toast',
        status: 'error',
        title: t('notifications.error'),
        description: t('notifications.failedToLoadTrainingAssessment'),
      });
    },
    refetchOnWindowFocus: false,
  });
};
